module.exports = __webpack_public_path__ + "img/businessImg.767ff4e2.png";